<template>
  <div>
    <div class="demo-style-switch" id="switch-style">
      <a id="toggle-switcher" class="switch-button">
        <v-icon color="grey">fa-solid fa-gear</v-icon>
      </a>
      <div class="switched-options">
        <div class="config-title">
          {{ $t('setting.languages') }}:
        </div>
        <ul>
            <li v-for="(languageObject, i) in languageItems" :key="i" class="my-1">
				<span class="pointer" style="color: black;" @click="languageModel = languageObject.value">
					<a class=" fs-14 font-weight-bold">{{ languageObject.text }}</a>
				</span>
			</li>
        </ul>
        <div class="config-title">
			{{ $t('setting.colors') }}:
        </div>
        <ul class="styles">
          <li><a href="#" onclick="setActiveStyleSheet('orange'); return false;" title="Orange">
              <div class="orange"></div>
            </a>
          </li>
          <li><a href="#" onclick="setActiveStyleSheet('yellow'); return false;" title="Yellow">
              <div class="yellow"></div>
            </a>
          </li>
          <li><a href="#" onclick="setActiveStyleSheet('blue'); return false;" title="Blue">
              <div class="blue"></div>
            </a>
          </li>
          <li><a href="#" onclick="setActiveStyleSheet('red'); return false;" title="Red">
              <div class="red"></div>
            </a>
          </li>
          <li><a href="#" onclick="setActiveStyleSheet('green'); return false;" title="Green">
              <div class="green"></div>
            </a>
          </li>
          <li><a href="#" onclick="setActiveStyleSheet('purple'); return false;" title="Purple">
              <div class="purple"></div>
            </a>
          </li>
          <!-- <li><a href="#" onclick="setActiveStyleSheet('blue'); return false;" title="Blue">
			<div class="blue"></div>
		  </a>
		</li>
		<li><a href="#" onclick="setActiveStyleSheet('slate'); return false;" title="Slate">
			<div class="slate"></div>
		</a>
		</li> -->
        </ul>
      </div>
    </div>
    <!-- 返回顶部 -->
    <div>
        <div class="back-to-top primary-bg" id="back-to-top">
            <div class="d-flex justify-center align-center mt-2">
                <v-icon>fa-solid fa-arrow-up</v-icon>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
		// 当前的语言环境
		languageModel: this.$store.getters.locale,
		// 语言环境选择框
		languageItems: [
			{ text: '中文（简体）', value: 'zh-CN' },
			{ text: '中文（繁體）', value: 'zh-HK' },
			{ text: 'English (US)', value: 'en-US' }
		]
	};
  },
  components: {},
  created() {
      this.backToTop();
  },
  mounted() {},
  computed: {},
  watch: {
	languageModel(newVal, oldVal) {
		this.changeLanguage(newVal);
	},
  },
  methods: {
	// 查询语言
	getLanguageText(){
		return this.languageItems.filter(lang => lang.value == this.languageModel)[0].text;
	},
	// 切换语言
	changeLanguage(locale) {
		this.$i18n.locale = locale;
		this.$store.dispatch("localeHandler", locale);
		// this.$router.go();
	},
    // 返回顶部
    backToTop(){
        $('#back-to-top').hide();
        // 获取要大于的高度
        // 当滚动条的位置处于距顶部300像素以下时，跳转链接出现，否则消失
        $(function () {
            $(window).scroll(function(){
                if ($(window).scrollTop() > 300){
                    $("#back-to-top").fadeIn(500);
                } else {
                    $("#back-to-top").fadeOut(500);
                }
            });
            //当点击跳转链接后，回到页面顶部位置
            $("#back-to-top").click(function(){
                if ($('html').scrollTop()) {
                    $('html').animate({ scrollTop: 0 }, 1000);
                    return false;
                }
                $('body').animate({ scrollTop: 0 }, 1000);
                return false;
            });
        });
    }
  },
};
</script>
<style scoped>
    .back-to-top {
        position: fixed;
        z-index: 999999999999;
        display: none;
        background-position: 0 0px;
        width: 40px;
        height: 40px;
        right: 10px;
        bottom: 10px;
        filter: alpha(opacity=80);
        cursor: pointer;
        border-radius: 50%;
    }
</style>


// WEBPACK FOOTER //
// src/components/Setting.vue